<main [@fadeInOut] role="main" id="main-heading" tabindex="0">
  <div class="wrapper">
    <div class="container-fluid" id="wrapper">
        <form [formGroup]="frmLCR" novalidate #createForm="ngForm" tabindex="0" role="form">
            <app-custom-sidebar [sidebarExpanded]="true">
              <ejs-accordion #sidebarAccordion id="accordion_html_markup" expandMode='Multiple'
                             (clicked)="onClick($event)"
                             (expanding)="expanding($event)"
                             (keydown.enter)="onClick($event)">
                <e-accordionitems>
                  <e-accordionitem expanded="true">
                    <ng-template #header>
                      <div class="container p-0">
                        <div class="row accordion-item-header">
                          <div class="container">
                            <div class="row p-0 m-0">
                              <div class="col-sm-8 text-start p-0 form-name-div">
                                <span tabindex="0">Labeler company</span>
                              </div>
                              <div class="col-sm-4 text-center">
                                <span tabindex="0">Version</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 accordion-item-header p-0">
                            <div class="container">
                              <div class="row">
                                <div class="col-sm-8 text-start p-0 text-wrap form-name-div" id="formName" tabindex="0">
                                  <ejs-tooltip id="tooltipObj" #tooltipObj opensOn='custom' content='' [enableHtmlParse]="false">
                                    <label class='tooltip-span padding-bottom-5' controlName="formName" (mouseenter)="showSFToolTip($event);" (mouseleave)="hideSFToolTip($event);"></label>
                                  </ejs-tooltip>
                                </div>
                                <div class="col-sm-2 text-end">
                                  <a href="javascript:void(0);" (click)="displayRevisionHistory($event)"
                                  role="link" tabindex="0" aria-label="display revision history" (keydown.enter)="displayRevisionHistory($event)">
                                    <label class='version'>{{versionToDisplay === '0.0' ? 'Draft' : versionToDisplay}}</label>
                                  </a>
                                </div>
                                <div class="col-sm-2" [class.draft]="isDraftMode">
                                  <span *ngIf="current" class="badge badge-success" tabindex="0">current</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #content>
                      <div class="container p-0">
                        <div class="row">
                          <div class="col-sm-6 p-0">
                            <label class="float-start basic-componentlabel" tabindex="0">Status</label>
                          </div>
                          <div class="col-sm-6">
                            <label class="float-start basic-componentlabel" tabindex="0">SPL Version</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6"><label tabindex="0">{{status}}</label></div>
                          <div class="col-sm-6"><label tabindex="0">{{splVersion}}</label></div>
                        </div>
                        <div class="row border-top">
                          <div class="col-sm-6 p-0">
                            <label for="setId" class="float-start basic-componentlabel" tabindex="0">
                              Set Id
                            </label>
                          </div>
                          <div class="col-sm-6 p-0 float-end">
                            <button class="btn btn-default" id="btnGenerateSetId" (click)="generateGUID()" tabindex="0" role="button" aria-label="generate new guid" (keydown.enter)="generateGUID()">
                              New GUID
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 px-4" id="setId">
                            <ejs-inplaceeditor id="setId" name="setId" mode="Popup"
                                               [model]="setIdModel" controlName="setId"
                                               [validationRules]="rules" type="Text" [value]="setId" (actionBegin)="editorChanged($event)">
                            </ejs-inplaceeditor>
                          </div>
                        </div>
                        <div class="row border-top">
                          <div class="col-sm-6 p-0">
                            <label class="float-start basic-componentlabel" tabindex="0">Last modified by</label>
                          </div>
                          <div class="col-sm-6">
                            <label class="float-start basic-componentlabel" tabindex="0">Last modified date</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <label class="float-start" tabindex="0">{{lastModifiedBy}}</label>
                          </div>
                          <div class="col-sm-6">
                            <label class="float-start" tabindex="0">{{lastModifiedDate}}</label>
                          </div>
                        </div>
                        <div class="row border-top">
                          <div class="col-sm-6 p-0">
                            <label class="basic-componentlabel m-0 p-0" tabindex="0">Business categories</label>
                          </div>
                          <div class="col-sm-6 p-0">
                            <ejs-inplaceeditor name="drpBusinessCategory" mode="Popup"
                                               type="DropDownList"
                                               [value]="frmDetailData?.busCategory?.label"
                                               [model]="businessCategoryModel" (actionBegin)="editorChanged($event)">
                            </ejs-inplaceeditor>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </e-accordionitem>
                </e-accordionitems>
              </ejs-accordion>
            </app-custom-sidebar>
          <div class="main-form" tabindex="0">
            <div class="container" tabindex="0">
              <div class="row padding-left" tabindex="0">
                <div class="col-sm-11" tabindex="0">
                  <div class="row">
                    <div class="col-sm-12">
                      <h1 tabindex="0" aria-label="Labeler Code Request" role="heading" aria-level="1">
                        {{isEditMode ? "Edit" : "New"}} Labeler Code Request
                      </h1>
                    </div>
                  </div>
                  <div class="row padding-left card-sticky" *ngIf="!current && frmDetailData && frmDetailData.majorRevision !== 0">
                    <div class="alert alert-warning text-center" role="alert" tabindex="0" aria-label="Not current version">
                      <i class="fas fa-exclamation-circle"></i>&nbsp;<b>NOT CURRENT VERSION</b> - Any changes made could overwrite a newer version of this form.
                    </div>
                  </div>
                  <div class="row">
                    <div class="card-body">
                      <div>
                        <div class="div-error-messages col-sm-12 padding-left">
                          <app-error-messages #errorMessages [splValidationMessages]='splValidationMessages'></app-error-messages>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 form-title-text mt-3" tabindex="0" aria-label="Labeler Code Request Details">
                      Labeler Code Request Details
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 ps-5">
                      <div class="row">
                        <div class="mb-1 col-sm-5">
                          <label for="drpSplTransmissionType">SPL submission type</label>
                          <ejs-dropdownlist [dataSource]='splTransmissionTypeLOV' [required]="splSubmissionTypeMissing"
                                            [fields]='splTransmissionTypeFields' [placeholder]='drpWaterMark' showClearButton=true
                                            formControlName="drpSplTransmissionType" [popupHeight]='ddwHeight'
                                            (change)="splTransmissionTypeSelectionChanged($event)" [popupWidth]='ddwWidth'
                                            [ngClass]="{ required:true, 'is-invalid': f.drpSplTransmissionType.errors && f.drpSplTransmissionType.errors.required }">
                          </ejs-dropdownlist>
                          <div *ngIf="submitted && f.drpSplTransmissionType.errors && f.drpSplTransmissionType.errors.required" class="alert-text"
                          tabindex="0" aria-label="SPL submission type is required">
                            SPL submission type is required
                          </div>
                        </div>
                        <div class="mb-1 col-sm-5">
                          <label for="splRevisionDate">SPL revision date</label>
                          <ejs-datepicker formControlName="splRevisionDate" (open)="onOpen($event)" [ngClass]="{'is-invalid required': f.splRevisionDate.errors && f.splRevisionDate.errors.required }"
                                          placeholder='Select a date' class="extra-padding" (change)="revisionDateChanged($event)" [format]='dateFormat'>
                          </ejs-datepicker>
                          <div *ngIf="f.splRevisionDate.errors && f.splRevisionDate.errors.required" class="alert-text"
                          tabindex="0" aria-label="Build SPL requires SPL revision date">
                            Build SPL requires SPL revision date
                          </div>
                        </div>
                        <div class="mb-1 col-sm-2">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 form-title-text top-padding-medium" tabindex="0" aria-label="Labeler Details">
                      Labeler Details
                    </div>
                  </div>
                  <div class="row margin-left">

                    <div class="card">
                      <div class="card-title text-white bg-primary p-2">
                        <span tabindex="0" aria-label="Labeler Company">Labeler Company</span>
                        <span class="float-end create-company-link">
                                        <a href="javascript:void(0);" (click)="showCompanyDialog()"
                                           class="create-company-link" id="create-company"
                                           role="link" tabindex="0" aria-label="create a new company" (keydown.enter)="showCompanyDialog()">Create new company</a>
                                    </span>
                      </div>
                      <div class="card-body basic-component">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="row">
                              <div class="mb-4 col-sm-5">
                                <label for="drpLabelerCompany">Labeler company</label>
                                <ejs-dropdownlist #lablerCompany [dataSource]='drpLabelerCompanyLOV' (change)="labelerCompanySelectionChanged($event)"
                                                  [fields]='labelerCompanyFields' [placeholder]='drpWaterMark' showClearButton=true
                                                  id="drpLabelerCompany" [required]="labelerCompanyMissing"
                                                  formControlName="drpLabelerCompany" [popupHeight]='ddwHeight' allowFiltering=true filterType="Contains"
                                                  [ngClass]="{ required:true, 'is-invalid': f.drpLabelerCompany.errors && f.drpLabelerCompany.errors.required }">
                                </ejs-dropdownlist>
                                <div *ngIf="submitted && f.drpLabelerCompany.errors" class="alert-text"
                                tabindex="0" aria-label="Labeler Company is required">
                                  Labeler Company is required
                                </div>
                              </div>
                              <div class="mb-4 col-sm-1">
                                <div>&nbsp;</div>
                                <div *ngIf="bShowViewCompanyLink" class="view-link">
                                  <a href='javascript:void(0);' (click)="showCompanyDialog(labelCompanyRevisionId)"
                                  role="link" tabindex="0" aria-label="view labeler company" (keydown.enter)="showCompanyDialog(labelCompanyRevisionId)">View</a>
                                </div>
                              </div>
                              <div class="mb-4 col-sm-2">
                                <label for="dunsNumber" tabindex="0">DUNS number</label>
                                <div class="top-padding-small"><label controlName="dunsNumber" class="label-text" tabindex="0"></label></div>
                              </div>
                              <div class="mb-4 col-sm-4">
                                <label for="drpNdcLabelerCode">NDC labeler code</label>
                                <ejs-dropdownlist #ndcLablerCode [dataSource]='drpNdcLabelerCodeLOV'
                                                  [fields]='labelerCodeFields' [placeholder]='drpWaterMark' showClearButton=true
                                                  formControlName="drpNdcLabelerCode" [popupHeight]='ddwHeight'
                                                  [ngClass]="{ required:true, 'is-invalid': f.drpNdcLabelerCode.errors && f.drpNdcLabelerCode.errors.required }">
                                </ejs-dropdownlist>
                                <div *ngIf="submitted && f.drpNdcLabelerCode.errors" class="alert-text">
                                  <div *ngIf="f.drpNdcLabelerCode.errors.required" tabindex="0" aria-label="NDC Labeler Code is required">NDC Labeler Code is required</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" *ngIf="isCompanyInactive">
                          <app-warning-icon #warningCompany [name]="inactiveLabelerCompanyName" [type]="iconTypeCompany"></app-warning-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="displayLabelerContact" class="row margin-left">
                    <div class="card">
                      <div class="card-title text-white bg-primary p-2" tabindex="0" aria-label="Labeler Contact">
                        Labeler Contact
                      </div>
                      <div class="card-body basic-component">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-3">
                              <label for="drpLabelerCompany" tabindex="0" aria-label="Labeler Contact">Labeler contact</label>
                              <div class="top-padding-small" *ngIf="bShowViewContactLink">
                                <label controlName="contactName" class="label-text" tabindex="0"></label> &nbsp;&nbsp; <a href='javascript:void(0);' (click)="showContactDialog(labelCompanyContactRevisionId)"
                                role="link" tabindex="0" aria-label="view labeler contact" (keydown.enter)="showContactDialog(labelCompanyContactRevisionId)">View</a>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <label for="phoneNumber" tabindex="0">Phone</label>
                              <div class="top-padding-small"><label controlName="phoneNumber" class="label-text" tabindex="0"></label></div>
                            </div>
                            <div class="col-sm-3">
                              <label for="emailAddress" tabindex="0">Email</label>
                              <div class="top-padding-small"><label controlName="emailAddress" class="label-text" tabindex="0"></label></div>
                            </div>
                            <div class="col-sm-4">
                              <label for="address" tabindex="0">Address</label>
                              <div class="row p-0">
                                <div class="top-padding-small"><label controlName="address" class="label-text" tabindex="0"></label></div>
                              </div>
                              <div class="row p-0">
                                <div class="top-padding-small"><label controlName="cityStateCountry" class="label-text" tabindex="0"></label></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" *ngIf="isContactInactive">
                          <app-warning-icon #warningContact [name]="inactiveLabelerContactName" [type]="iconTypeContact"></app-warning-icon>
                        </div>
                        <div class="row" *ngIf="contactNotAssociated">
                          <div class="alert-text small-margin" tabindex="0" aria-label="Please update the selected company record to include required contact information"
                          >Please update the selected company record to include required contact information.</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row sticky">

                    <div class="col-sm-12 center-block buttons-bar">

                      <!--<div class="pull-start text-start sidebar-back-to">-->
                      <span class="ps-1 float-start">
                                    <a class="vertical-middle text-white" href="/lcr-form-dashboard">
                                        <i class="fas fa-angle-left" aria-hidden="true"></i>
                                        Back to list
                                    </a>
                                </span>
                      <!--</div>-->

                      <span class="margin-right">
                                    <button class="btn btn-info margin-right" id="btnSaveDraft"
                                            (click)="saveLCRForm(true, false, false)"
                                            [disabled]="!bHasPermission || pageLoading"
                                            tabindex="0" role="button" aria-label="save a draft" (keydown.enter)="saveLCRForm(true, false, false)">
                                        Save a draft
                                        <span *ngIf="saveLoading"><img src="../../../assets/images/loading-info.gif" /></span>
                                    </button>
                                </span>

                      <span class="me-1">
                                    <button class="btn btn-warning margin-right" (click)="validateLCR()"
                                            [disabled]="!bHasPermission || pageLoading"
                                            tabindex="0" role="button" aria-label="validate" (keydown.enter)="validateLCR()">
                                        Validate
                                        <span *ngIf="validateLoading"><img src="../../../assets/images/loading-orange.gif" /></span>
                                    </button>
                                </span>

                      <span class="build-spl">
                                    <button class="build-spl-button margin-right" (click)="buildLCRModal()"
                                            [disabled]="!bHasPermission || pageLoading || contactNotAssociated"
                                            tabindex="0" role="button" aria-label="build SPL" (keydown.enter)="buildLCRModal()">
                                        <span class="build-spl-button-span vertical-middle">Build SPL</span>
                                        <span *ngIf="buildLoading"><img src="../../../assets/images/loading-green.gif" /></span>
                                    </button>
                                    <ejs-checkbox #splCheckbox cssClass="e-small padding-right vertical-middle" [disabled]="!bHasPermission || pageLoading" label="Ignore warnings" (change)="ignoreWarningsToggle()"></ejs-checkbox>
                                </span>

                      <app-delete-button *ngIf="hasDeletePermission" #deleteButton
                                         class=""
                                         [isDraft]="isDraftMode"
                                         [revisionId]="lcrRevisionId"
                                         [canDelete]="!!lcrRevisionId"
                                         [apiController]="'LCRForms'"
                                         [redirectPage]="'lcr-form-dashboard'"
                                         [(pageLoading)]="pageLoading">

                      </app-delete-button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
    </div>
</div>

<div *ngIf="pageLoading">
    n
    <div id="loading"></div>
</div>

<ejs-dialog #revHistoryDialog id="revHistoryDialog" [isModal]='isModal' [animationSettings]='animationSettings'
                        [closeOnEscape]='true' [showCloseIcon]='false' [width]='modalWidth' [position]='position' [height]='modalHeight'
                        (overlayClick)="onOverlayClick()" [visible]='revHistoryVisible'>
    <div class="card">
        <div class="card-header bg-primary">
            <h4 class="card-title text-white" tabindex="0" aria-label="Version History" role="heading" aria-level="4"> Version History</h4>
        </div>
        <div class="card-body">
            <table class="table table-inner table-striped" role="table">
                <thead role="rowgroup">
                    <tr role="row">
                        <th role="columnheader" tabindex="0" aria-label="Form version">Form version</th>
                        <th role="columnheader" tabindex="0" aria-label="Modified By">Modified By</th>
                        <th role="columnheader" tabindex="0" aria-label="Modified Date">Modified Date</th>
                    </tr>
                </thead>
                <tbody role="rowgroup">
                    <tr *ngFor="let item of lcrRevisions; let i = index;" role="row">
                        <td role="gridcell" tabindex="0" aria-label="cell of form version">
                            <a href="javascript:void(0);" (click)="goToRevision(item.lcrRevisionId)"
                            role="link" tabindex="0" aria-label="go to form revision" (keydown.enter)="goToRevision(item.lcrRevisionId)">{{item.formVersion}}</a>
                        </td>
                        <td role="gridcell" tabindex="0" aria-label="cell of modified by">{{item.modifiedBy }}</td>
                        <td role="gridcell" tabindex="0" aria-label="cell of modified date">{{item.modifiedDate | dateToLocale: 'true'}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center">
            <button id="revHistClose" class="btn btn-default" (click)="revisionHistoryClose($event)" data-ripple="true"
            tabindex="0" role="button" aria-label="close" (keydown.enter)="revisionHistoryClose($event)">
                Close
            </button>
        </div>
    </div>
</ejs-dialog>

<ejs-dialog #buildModalDialog [isModal]='isModal' [buttons]='buildDlgButtons' [visible]='buildModalDialogVisible'
                        [position]='position' [animationSettings]='animationSettings' [width]='modalWidth' (open)="splVersionModalOpen()">
    <ng-template #content>
        <div class="card">
            <div class="card-header bg-primary">
                <h3 class="card-title text-white" tabindex="0" aria-label="Update SPL Version Number" role="heading" aria-level="3">Update SPL Version Number</h3>
            </div>
            <div class="card-body">
                <label id="splVersionUpdate-label">The SPL Version number will be updated to the next major version below</label>
                <input id='splVersionModalInput' type="number" min="1" oninput="this.value = Math.abs(this.value) || this.value > 0"
                             onkeydown="if(event.key==='.'){event.preventDefault();}"
                             class="form-control" (blur)="validateSplVersionInput($event)"
                             aria-labelledby="splVersionUpdate-label" role="spinbutton" tabindex="0"/>

                <div *ngIf="invalidSplVersion" class="alert-text">
                    <span tabindex="0" aria-label="The SPL version can't be blank">The SPL version can't be blank</span>
                </div>
            </div>
        </div>
    </ng-template>
</ejs-dialog>

<!-- Company Detail Dialog box -->
<ejs-dialog id='dialog' #companyDialog isModal='true'
                        [animationSettings]='animationSettings' [visible]='hidden' width="80%">
    <ng-template #content class="modal-header">
        <form name="modalCompanyForm">
            <div class="card">
                <div class="card-header bg-primary">
                    <h4 class="card-title text-white" tabindex="0" aria-label="Company Details" role="heading" aria-level="4">Company Details</h4>
                </div>

                <div class="card-body">
                    <app-company-details #companyDetails (companyOutput)="modalCompany($event)"
                                                             (cancelButtonClickedOutput)="companyDialogCancelButtonClicked()"
                                                             [parentComponentInput]="parentComponent">
                    </app-company-details>
                </div>

            </div>
        </form>
    </ng-template>
</ejs-dialog>

<!-- Contact Detail Dialog box -->
<div class="row">
    <div #container class='root-container'></div>
    <ejs-dialog id='dialog' #contactDialog isModal='true' [animationSettings]='animationSettings' [visible]='hidden' width="80%">
        <ng-template #content class="modal-header">
            <form name="modalContactForm">
                <div class="card">
                    <div class="card-header bg-primary">
                        <h4 class="card-title text-white" tabindex="0" aria-label="Contact Details" role="heading" aria-level="4">Contact Details</h4>
                    </div>
                    <div class="card-body">
                        <app-contact #contact (contactOutput)="modalContact($event)"
                                                 (cancelButtonClickedOutput)="contactDialogCancelButtonClicked()"
                                                 (contactRetrievedOutput)="contactRetrieved(contact)"
                                                 [parentComponentInput]="parentComponent">
                        </app-contact>
                    </div>
                </div>
            </form>
        </ng-template>
    </ejs-dialog>
</div>
</main>
